import { Tool } from './base';

export class TrendMicroVisionOneTool extends Tool {
  public readonly toolName = 'Trend Micro Vision One';

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string
  ): string {
    const encodedRenderedContent = encodeURIComponent(renderedContent);
    //https://portal.xdr.trendmicro.com
    //Set time to Last 30 days
    const currentDate = new Date();
    const myPastDate = new Date(currentDate);
    myPastDate.setDate(myPastDate.getDate() - 30);
    return `${rootURL}#/app/search?start=${myPastDate.valueOf()}&end=${currentDate.valueOf()}&search_source=telemetry&search_query=${encodedRenderedContent}`;
  }
}
